import Api,{ HttpResponse, Result } from './../utils/request';

class FontService{
    
    //删除字体文件信息
    static async RemoveTripFile(id:number):Promise<HttpResponse>{
        return Api.Post("triptemplate_RemoveTripFile",{id})
    }

    //获取字体管理文件信息
    static async GetManagerFontList(params:any):Promise<HttpResponse>{
        return Api.Post("triptemplate_GetManagerFontList",params)
    }

    //获取字体文件信息
    static async GetAllFontsAsync():Promise<HttpResponse>{
        return Api.Post("triptemplate_GetFontList",{})
    }

    //新增一个字体
    static async SetFontAsync(params : any):Promise<HttpResponse>{
        params.Id=0
        params.lable = params.label
        return Api.Post("triptemplate_SetTripFile",params)
    }
}
export default FontService;